"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _col = _interopRequireDefault(require("../../../core/col"));
var _row = _interopRequireDefault(require("../../../core/row"));
var _alert = _interopRequireDefault(require("../../../core/alert"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("h6", null, "Deadlines");
var _ref2 = /*#__PURE__*/_react.default.createElement("h6", null, "Totals");
var _ref3 = /*#__PURE__*/_react.default.createElement("br", null);
class DeadlinesAndRaces extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_countRacesByTier", (divID, racingStartDays, nations) => {
      const tierStartDays = racingStartDays.filter(r => r.tierRef === divID);
      const counts = nations.map(n => {
        return {
          nationRef: n.refCode,
          nationCount: this._getNationRaces(n.refCode, tierStartDays).length
        };
      });
      counts.push({
        nationRef: 'divTotal',
        nationCount: tierStartDays.length
      });
      return counts;
    });
    _defineProperty(this, "_getNationRaces", (nationRef, startDates) => {
      return startDates.filter(d => d.application.site && d.application.site.county && d.application.site.county.nationRef === nationRef);
    });
    _defineProperty(this, "_getColSize", (info, text) => {
      if (this._showDeadlines()) {
        switch (info) {
          case 'DIV':
            return /*#__PURE__*/_react.default.createElement(_col.default, {
              xs: 2,
              sm: 3,
              md: 2,
              xl: 3
            }, text);
          case 'DEADLINES':
            return /*#__PURE__*/_react.default.createElement(_col.default, {
              xs: 3
            }, text);
          case 'NATIONS':
            return /*#__PURE__*/_react.default.createElement(_col.default, {
              xs: 7,
              sm: 6,
              md: 7,
              xl: 6,
              class: "text-xs-center"
            }, /*#__PURE__*/_react.default.createElement("span", {
              className: "text-xs-center"
            }, text));
        }
      } else {
        switch (info) {
          case 'DIV':
            return /*#__PURE__*/_react.default.createElement(_col.default, {
              xs: 3
            }, text);
          case 'DEADLINES':
            return null;
          case 'NATIONS':
            return /*#__PURE__*/_react.default.createElement(_col.default, {
              xs: 9
            }, text);
        }
      }
    });
    _defineProperty(this, "_showDeadlines", () => {
      const tiersWithDeadlines = this.props.defaultTiers.filter(tier => !tier.isExpired && tier.isInCalendar && tier.applicationClosingDate);
      return tiersWithDeadlines.length && (!this.props.calendar.closingDate || this.props.calendar.closingDate > this.props.today);
    });
  }
  render() {
    const tiers = this.props.defaultTiers.filter(tier => !tier.isExpired && tier.isInCalendar);
    const racingStartDays = this.props.calendar.applicationRacing.filter(r => r.isRaceStartDay && r.application.applicationStatusRef !== 'DECL');
    const nations = this.props.nationRefs.filter(n => !n.expired && this._getNationRaces(n.refCode, racingStartDays).length);
    return /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "warning"
    }, /*#__PURE__*/_react.default.createElement(_row.default, null, this._getColSize('DIV', ''), this._getColSize('DEADLINES', _ref), this._getColSize('NATIONS', /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, nations.map(n => /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: Math.floor(12 / (nations.length + 1)),
      key: n.refCode
    }, /*#__PURE__*/_react.default.createElement("h6", null, n.description))), /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: Math.floor(12 / (nations.length + 1))
    }, _ref2)))), tiers.map(t => /*#__PURE__*/_react.default.createElement(_row.default, {
      key: t.id
    }, this._getColSize('DIV', t.tierDescription), this._getColSize('DEADLINES', !t.applicationClosingDate ? '' : (0, _occasion.default)(t.applicationClosingDate, 'D MMMM')), this._getColSize('NATIONS', /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this._countRacesByTier(t.tierRef, racingStartDays, nations).map(c => /*#__PURE__*/_react.default.createElement(_col.default, {
      xs: Math.floor(12 / (nations.length + 1)),
      className: "text-center",
      key: c.nationRef
    }, c.nationCount)))))), !this._showDeadlines() ? null : /*#__PURE__*/_react.default.createElement("p", null, _ref3, "Applications may continue to be made after the deadlines shown above until", ' ', this.props.calendar.closingDate ? (0, _occasion.default)(this.props.calendar.closingDate, 'D MMMM YYYY') : 'the calendar is locked', ", but will be shown as late."));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(DeadlinesAndRaces, "partialQueries", {
  Calendar: {
    id: true,
    closingDate: true,
    applicationRacing: {
      id: true,
      tierRef: true,
      isRaceStartDay: true,
      application: {
        applicationStatusRef: true,
        site: {
          county: {
            nationRef: true
          }
        }
      }
    }
  },
  DefaultTiers: {
    id: true,
    tierRef: true,
    tierDescription: true,
    isExpired: true,
    isInCalendar: true,
    applicationClosingDate: true
  },
  NationRef: {
    id: true,
    refCode: true,
    description: true,
    isExpired: true
  }
});
var _default = exports.default = DeadlinesAndRaces;